//
//
//
//
//
//

import * as monaco from "monaco-editor";
import { debounce } from "quasar";
import { SuggestAdapter } from "monaco-editor/esm/vs/language/typescript/languageFeatures";
import { MONACO_EDITOR_PROPS } from "./AQMonacoEditor.const";

const originalProvideCompletionItems = SuggestAdapter.prototype.provideCompletionItems;

export default {
    name: "AQMonacoEditor",
    props: {
        ...MONACO_EDITOR_PROPS
    },
    data() {
        return {
            editor: "",
            monacoData: "",
            registerInstance: null
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.monacoData = newValue || "";
            },
            immediate: true
        }
    },
    mounted() {
        this.createMonaco();
        this.setNewSuggestions();
        this.$nextTick(() => this.$emit("init"));
        this.$root.$on("emitNewValueMonaco", data => {
            this.$emit("input", data);
        });
    },
    beforeDestroy() {
        if (this.registerInstance) {
            this.registerInstance.dispose();
        }
        monaco.editor.getModels().forEach(model => model.dispose());
        this.$root.$off("emitNewValueMonaco");
    },
    methods: {
        insertText(text) {
            this.editor.trigger("keyboard", "type", { text });
        },
        setFocus() {
            this.editor.focus();
        },
        showViewProblems() {
            this.editor.trigger("editor", "editor.action.marker.next");
        },
        showCommandPalette() {
            this.setFocus();
            this.editor.trigger("editor", "editor.action.quickCommand", "");
        },
        createMonaco() {
            const el = this.$refs.editor;
            monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
                noSemanticValidation: false,
                noSyntaxValidation: false
            });
            monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
                target: monaco.languages.typescript.ScriptTarget.ES6,
                allowNonTsExtensions: true
            });

            if (this.addGlobalContent) {
                monaco.languages.typescript.javascriptDefaults.addExtraLib(
                    `import * as ts from './typescript.d.ts';
                    declare global {
                        ${this.addGlobalContent}
                    }
                    `, "global.d.ts"
                );
            }

            this.editor = monaco.editor.create(el, {
                value: this.monacoData,
                language: this.language,
                readOnly: this.readonly,
                theme: this.theme,
                automaticLayout: this.autoResize
            });

            this.editor.onDidChangeModelContent(() => {
                this.emitNewValue();
            });

            this.emitNewValue = debounce(() => {
                this.$emit("input", this.editor.getValue());
            }, 600);

            if (this.receiveValidStatus) {
                const { setModelMarkers } = monaco.editor;
                const checkIfValid = (markers) => {
                    const errors = (markers || []).filter(marker => marker.severity === monaco.MarkerSeverity.Error);
                    const hasErrors = !!errors.length;

                    this.$emit("update:errorsCount", errors.length);
                    if (this.contentNotValid !== hasErrors) {
                        this.$emit("update:contentNotValid", hasErrors);
                    }
                };

                monaco.editor.setModelMarkers = (model, owner, markers) => {
                    setModelMarkers.call(monaco.editor, model, owner, markers);
                    checkIfValid(markers);
                };
            }
        },

        setNewSuggestions() {
            const buildSuggestions = (data) => {
                const newSuggestions = [];
                if (this.suggestions && this.suggestions.length) {
                    this.suggestions.forEach(item => {
                        newSuggestions.push({
                            label: item.label || "",
                            kind: monaco.languages.CompletionItemKind[item.kind || "Variable"],
                            detail: item.detail || "",
                            insertText: item.value || "",
                            sortText: item.sortText || "",
                            data
                        });
                    });
                }
                return newSuggestions;
            };
            this.registerInstance = monaco.languages.registerCompletionItemProvider(this.language, {
                provideCompletionItems(model, position) {
                    const word = model.getWordUntilPosition(position);
                    const range = {
                        startLineNumber: position.lineNumber,
                        endLineNumber: position.lineNumber,
                        startColumn: word.startColumn,
                        endColumn: word.endColumn
                    };
                    return {
                        suggestions: buildSuggestions(range)
                    };
                }
            });

            SuggestAdapter.prototype.provideCompletionItems = async function provideCompletionItems(...args) {
                const result = await originalProvideCompletionItems.apply(this, args);
                const { suggestions } = result || {};
                let filteredSuggestions = [];
                if (suggestions) {
                    filteredSuggestions = suggestions.filter(i => i.kind === 3 || (i.kind === 9 && !i.tags.length) || (i.kind === 1 && i.sortText === "1"));
                }

                return { suggestions: filteredSuggestions };
            };
        }
    }
};
